<template>
  <div align="center">
    <!-- Input que abre explorador de archivos -->
    <input
      v-show="false"
      type="file"
      ref="archivo"
      accept=".pdf, .xlsx, .jpg, .png, .mp3, .wav, .msg, .zip, .tar, .eml"
      @click="selectFile"
      @change="ChangeArchivo"
    />
    <v-data-table
      :headers="headers"
      :items="desserts"
      item-key="ID_Registro"
      class="elevation-1"
    >
      <!-- Obligatorio -->
      <template v-slot:item.Obligatoriedad="{ item }">
        <v-tooltip location="bottom" color="white">
          <template v-slot:activator="{ props }">
            <v-icon
              :color="
                item.raw.Obligatorio == 'S' ? 'red' : 'blue-grey-lighten-5'
              "
              v-bind="props"
              >{{
                item.raw.Obligatorio == "S"
                  ? "mdi-alert-circle"
                  : "mdi-information-slab-circle-outline"
              }}</v-icon
            >
          </template>
          <span>{{
            item.raw.Obligatorio == "S" ? "Obligatorio" : "Opcional"
          }}</span>
        </v-tooltip>
        <!-- Documentos sin cargar -->
        <v-tooltip location="bottom" color="white">
          <template v-slot:activator="{ props }">
            <v-icon
              :color="
                (item.raw.DescArchivo == null || item.raw.DescArchivo == '') &&
                !item.raw.MuestraArchivo
                  ? 'red'
                  : 'green'
              "
              v-bind="props"
              >{{
                (item.raw.DescArchivo == null || item.raw.DescArchivo == "") &&
                !item.raw.MuestraArchivo
                  ? "mdi-file-document-remove-outline"
                  : "mdi-file-document-check-outline"
              }}</v-icon
            >
          </template>
          <span>{{
            (item.raw.DescArchivo == null || item.raw.DescArchivo == "") &&
            !item.raw.MuestraArchivo
              ? "Documento sin cargar"
              : "Documento Cargado"
          }}</span>
        </v-tooltip>
        <!-- Documentos Cargado -->
        <v-tooltip
          v-if="item.raw.IconoArchivo != null && item.raw.IconoArchivo != ''"
          location="bottom"
          color="white"
        >
          <template v-slot:activator="{ props }">
            <v-icon color="green" v-bind="props">{{
              item.raw.IconoArchivo == null || item.raw.IconoArchivo == ""
                ? ""
                : item.raw.IconoArchivo
            }}</v-icon>
          </template>
          <span>{{
            item.raw.DescArchivo == null || item.raw.DescArchivo == ""
              ? ""
              : item.raw.DescArchivo
          }}</span>
        </v-tooltip>
      </template>
      <!-- Subir Archivo -->
      <template v-slot:item.Anexar="{ item }">
        <v-tooltip location="bottom" color="white">
          <template v-slot:activator="{ props }">
            <v-icon
              :color="
                item.raw.TipoContenido == '1' || item.raw.TipoContenido == '2'
                  ? 'cyan'
                  : item.raw.TipoContenido == '5' // Consolidado
                  ? 'blue'
                  : !item.raw.Combinado
                  ? 'red'
                  : 'green'
              "
              @click="
                SubirArchivo(
                  item.raw,
                  item.raw.TipoContenido == '1' || item.raw.TipoContenido == '2'
                    ? 1
                    : 3
                )
              "
              v-bind="props"
              >{{
                item.raw.TipoContenido == "1" || item.raw.TipoContenido == "2"
                  ? "mdi-upload"
                  : item.raw.TipoContenido == "5" // Consolidado
                  ? "mdi-file-send"
                  : !item.raw.Combinado
                  ? "mdi-clipboard-remove-outline"
                  : "mdi-clipboard-check-outline"
              }}</v-icon
            >
          </template>
          <span>{{
            item.raw.TipoContenido == "1" || item.raw.TipoContenido == "2"
              ? "Subir Archivo"
              : item.raw.TipoContenido == "5" // Consolidado
              ? "Seleccione para consolidar"
              : !item.raw.Combinado
              ? " Seleccione para combinar"
              : " Documento para combinar"
          }}</span>
        </v-tooltip>
      </template>
      <!-- Vista Archivo Temporal -->
      <template v-slot:item.View="{ item }">
        <v-tooltip
          v-if="item.raw.TipoContenido == '3' && item.raw.Combinado"
          location="bottom"
          color="white"
        >
          <template v-slot:activator="{ props }">
            <v-icon
              @click="SubirArchivo(item.raw, 2)"
              color="green-lighten-2"
              v-bind="props"
              >mdi-file-eye-outline</v-icon
            >
          </template>
          <span>Vista previa</span>
        </v-tooltip>
      </template>
      <!-- Documento Actual -->
      <template v-slot:item.Actual="{ item }">
        <v-tooltip
          v-if="item.raw.MuestraArchivo"
          location="bottom"
          color="white"
        >
          <template v-slot:activator="{ props }">
            <v-icon
              @click="DocumentoActual(item.raw)"
              color="teal-accent-4"
              v-bind="props"
              >mdi-comment-eye-outline</v-icon
            >
          </template>
          <span>Documento Actual</span>
        </v-tooltip>
      </template>
      <!-- Histórico -->
      <template v-slot:item.Historico="{ item }">
        <v-tooltip location="bottom" color="white">
          <template v-if="item.raw.MuestraArchivo" v-slot:activator="{ props }">
            <v-icon
              @click="historicoconsultadocumentos(item.raw)"
              color="blue-darken-3"
              v-bind="props"
              >mdi-archive-eye-outline</v-icon
            >
          </template>
          <span>Histórico</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <div align="right">
      <br />
      <v-btn size="x-large" color="green" text @click="ValidateCampos">
        Guardar
      </v-btn>
    </div>
    <!-- Linea Progreso -->
    <div class="d-flex align-center flex-column">
      <!-- Linea de progreso -->
      <v-dialog v-model="progreso" persistent width="auto">
        <v-card color="red-darken-4">
          <v-card-text>
            Espera un momento...
            <v-toolbar align="center" color="red-darken-4">
              <v-img
                class="mx-auto"
                :width="5"
                src="/static/iconos/logo2.png"
              ></v-img>
            </v-toolbar>
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <!-- Visores Consolidado -->
    <v-dialog v-model="modalConsolidar" persistent max-width="1200px">
      <v-toolbar dark color="red-darken-4">
        <v-toolbar-title
          ><v-icon left>mdi-eye-settings-outline</v-icon> Seleccionar archivo
          {{ infollaves.Contrato != null ? infollaves.Contrato : "" }} -
          {{ infollaves.Ref_1 != null ? infollaves.Ref_1 : "" }} -
          {{ infollaves.Document_ID != null ? infollaves.Document_ID : "" }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn
            class="d-none d-md-block"
            dark
            text
            @click="modalConsolidar = false"
            >Cerrar</v-btn
          >
        </v-toolbar-items>
      </v-toolbar>
      <card-visoresconsolidado
        v-if="modalConsolidar"
        :infollaves="infollaves"
        :TipoDocumemto="TipoDocumemto"
        v-bind:modalConsolidar="modalConsolidar"
        v-on:update:modalConsolidar="modalConsolidar = $event"
      ></card-visoresconsolidado>
    </v-dialog>

    <!-- Visores -->
    <v-dialog v-model="modal" persistent max-width="1200px">
      <v-toolbar dark color="red-darken-4">
        <v-toolbar-title
          ><v-icon left>mdi-eye-settings-outline</v-icon> Visualizar archivo
          {{ infollaves.Contrato != null ? infollaves.Contrato : "" }} -
          {{ infollaves.Ref_1 != null ? infollaves.Ref_1 : "" }} -
          {{ infollaves.Document_ID != null ? infollaves.Document_ID : "" }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn class="d-none d-md-block" dark text @click="modal = false"
            >Cerrar</v-btn
          >
        </v-toolbar-items>
      </v-toolbar>
      <card-visores
        v-if="LinkDocumento != null"
        :LinkDocumento="LinkDocumento"
        :NombreDocumento="NombreDocumento"
        :Formato="Formato"
        :infollaves="infollaves"
        :TipoDocumemto="TipoDocumemto"
      ></card-visores>
      <card-visoresconsolidado
        v-if="componenteview == 1"
        :LinkDocumento="LinkDocumento"
        :NombreDocumento="NombreDocumento"
        :Formato="Formato"
        :infollaves="infollaves"
        :TipoDocumemto="TipoDocumemto"
      ></card-visoresconsolidado>
    </v-dialog>

    <!-- Histórico de documentos -->
    <v-dialog v-model="modal1" persistent max-width="1200px">
      <v-toolbar dark color="red-darken-4">
        <v-toolbar-title
          ><v-icon left>mdi-archive-eye-outline</v-icon>
          Histórico de archivos
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn class="d-none d-md-block" dark text @click="modal1 = false"
            >Cerrar</v-btn
          >
        </v-toolbar-items>
      </v-toolbar>
      <card-historicodoc
        v-if="itemconsultadocumento != null"
        :ConsulaDocumento="itemconsultadocumento"
      ></card-historicodoc>
    </v-dialog>
  </div>
</template>
<script>
import store from "@/store";
import visores from "@/views/TCI/Documentos/DocumentosComponents/Visores/Visores.vue";
import visoresConsolidado from "@/views/TCI/Documentos/DocumentosComponents/Visores/VisoresConsolidado.vue";
import historicodocumentos from "@/views/TCI/Documentos/ConsultaDocumentos/HistoricoDocumento.vue";
export default {
  name: "documentos-modal",
  components: {
    "card-visores": visores,
    "card-visoresconsolidado": visoresConsolidado,
    "card-historicodoc": historicodocumentos,
  },
  props: {
    infollaves: {
      type: Object,
      default: null,
      Description: "Información de llaves",
    },
    infoCampo: {
      type: Object,
      default: null,
      Description: "Información del campo tipo Datepicker para ser añadido",
    },
    acceso: {
      type: String,
      default: "",
      Description: "Conocer el acceso a la acción manual",
    },
  },
  data() {
    return {
      //item: this.infoCampo,
      itemdocumento: [],
      itemconsultadocumento: [],
      progreso: false,
      modal: false,
      modal1: false,
      modalConsolidar: false,
      base64String: "", // Aquí se almacenará el Base64
      dessertsresult: [],
      dessertsvista: [],
      archivo: null,
      RutaFisica: null,
      LinkDocumento: null,
      NombreDocumento: null,
      TipoDocumemto: null,
      Formato: null,
      vistanex: 0,
      headers: [
        { title: "Descripcion", key: "Descripcion", sortable: false },
        {
          title: "Obligatorio/Subido",
          key: "Obligatoriedad",
          sortable: false,
          align: "center",
        },
        { title: "Anexar", key: "Anexar", sortable: false, align: "center" },
        {
          title: "Vista previa",
          key: "View",
          sortable: false,
          align: "center",
        },
        {
          title: "Actual",
          key: "Actual",
          sortable: false,
          align: "center",
        },
        {
          title: "Historico",
          key: "Historico",
          sortable: false,
          align: "center",
        },
      ],
      desserts: [],
      arraydocumentos: [],
      documentocon: [],
    };
  },
  methods: {
    // Validate Campos
    async ValidateCampos() {
      var validate = false;
      for (var i = 0; i < this.desserts.length; i++) {
        if (this.desserts[i].Obligatorio == "S") {
          if (
            this.desserts[i].IconoArchivo == null ||
            this.desserts[i].DescArchivo == null ||
            this.desserts[i].IconoArchivo == "" ||
            this.desserts[i].DescArchivo == ""
          ) {
            validate = true;
            break;
          }
        }
      }
      // Consultas a Ejecutar
      if (!validate) {
        if (this.dessertsresult != null && this.dessertsresult.length > 0) {
          this.save();
        } else {
          this.$swal({
            icon: "warning",
            title: "No existente archivos guardados.",
            html: " Si quiere guardar un nuevo documento, cargue el archivo o seleccione un combinado.",
          });
        }
      } else {
        this.$swal({
          icon: "warning",
          title: "Archivos Obligatorios.",
          html: " Existen documentos obligatorios, pero no contienen archivos cargados o selección de combinados.",
        });
      }
    },

    // Guardado de datos
    async save() {
      if (this.dessertsresult != null && this.dessertsresult.length > 0) {
        this.progreso = true;
        var userperfil = this.$store.getters.userperfil.userInfo;
        var perfil = this.$store.getters.userperfil.infoperfil;
        var infoDocumentos = [];
        let formData = new FormData();
        if (this.vistanex == 1) {
          if (this.dessertsresult != null && this.dessertsresult != []) {
            for (var i = 0; i < this.dessertsresult.length; i++) {
              // Guardamos el archivo en base 64 y lo dejamos en un array
              var file = this.dessertsresult[i].Archivo;
              formData.append("files", file);

              var dataArchive = {
                posicion: i,
                Documentos_ID: this.dessertsresult[i].Documentos_ID,
              };

              infoDocumentos.push(dataArchive);
            }
          }
          //data.append("InfoDocumentos", JSON.stringify(this.dessertsresult));
        } else {
          //data.append("InfoDocumentos", JSON.stringify(this.dessertsvista));
        }

        // Información Data
        var data = {
          TypeDocument_ID:
            this.infollaves.TypeDocument_ID == null
              ? ""
              : this.infollaves.TypeDocument_ID,
          Document_ID:
            this.infollaves.Document_ID == null
              ? ""
              : this.infollaves.Document_ID,
          Contrato:
            this.infollaves.Contrato == null ? "" : this.infollaves.Contrato,
          Ref_1: this.infollaves.Ref_1 == null ? "" : this.infollaves.Ref_1,
          IDServicio:
            this.infollaves.IDServicio == null
              ? ""
              : this.infollaves.IDServicio,
          Soporte_ID:
            this.infollaves.Secuencia_ID == null
              ? null
              : parseInt(this.infollaves.Secuencia_ID),
          Solicitud:
            this.infollaves.Solicitud == null ? "" : this.infollaves.Solicitud,
          IDPoliza:
            this.infollaves.IDPoliza == null ? "" : this.infollaves.IDPoliza,
          UsuarioLogin:
            userperfil.Usuario_ID == null ? "" : userperfil.Usuario_ID,
          PerfilLogin: perfil.Perfil_ID == null ? "" : perfil.Perfil_ID,
          Vista: this.vistanex == 1 ? "1" : "2",
        };

        // Agregar el array de Documentos como JSON en un campo de texto
        formData.append("InfoDocumentos", JSON.stringify(infoDocumentos));

        // Agregar el array de objetos como JSON en un campo de texto
        formData.append("metadata", JSON.stringify(data));
        // Agregar el array de objetos como JSON en un campo de texto
        formData.append("infoArchive", JSON.stringify(null));

        this.axios
          .post("/archivosdocumentos/CR0", formData)
          .then((response) => {
            if (this.vistanex == 1) {
              this.$swal({
                icon: "info",
                title: "Archivos",
                html: response.data[0],
              });
              this.dessertsresult = [];
              this.consultardoc();
            } else {
              this.RutaFisica = response.data[3];
              this.LinkDocumento = response.data[4];
              this.NombreDocumento = response.data[5];
              this.Formato = response.data[6];
              this.modal = true;
            }
          })
          .catch((error) => {
            const registro = error.response.data;
            const mensajeerror = registro.Mensaje || registro.ExceptionMessage;
            switch (error.response.status) {
              case 404:
                this.$swal({
                  icon: "warning",
                  title: "Consulta inexistente.",
                  html: " [404] No existen datos para esta consulta.",
                });
                break;
              default:
                this.$swal({
                  icon: "error",
                  title: "Error al consultar",
                  html:
                    " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                    mensajeerror +
                    "</code></small>",
                });
                break;
            }
          })
          .finally(() => {
            this.progreso = false;
          });
      } else {
        this.$swal({
          icon: "warning",
          title: "No existen Archivos.",
          html: " No existen combinación o archivos cargados.",
        });
      }
    },

    // Guardado de datos
    async consultardoc() {
      this.progreso = true;
      let formData = new FormData();
      // Información Data
      var data = {
        TypeDocument_ID:
          this.infollaves.TypeDocument_ID == null
            ? ""
            : this.infollaves.TypeDocument_ID,
        Document_ID:
          this.infollaves.Document_ID == null
            ? ""
            : this.infollaves.Document_ID,
        Contrato:
          this.infollaves.Contrato == null ? "" : this.infollaves.Contrato,
        Ref_1: this.infollaves.Ref_1 == null ? "" : this.infollaves.Ref_1,
        IDServicio:
          this.infollaves.IDServicio == null ? "" : this.infollaves.IDServicio,
        Soporte_ID:
          this.infollaves.Secuencia_ID == null
            ? null
            : this.infollaves.Secuencia_ID,
        Solicitud:
          this.infollaves.Solicitud == null ? "" : this.infollaves.Solicitud,
        IDPoliza:
          this.infollaves.IDPoliza == null ? "" : this.infollaves.IDPoliza,
        UsuarioLogin: null,
        PerfilLogin: null,
        ID_Comunicacion: null,
        Vista: this.vistanex == 1 ? "1" : "2",
      };

      console.log(this.arraydocumentos);
      // Agregar el array de Documentos como JSON en un campo de texto
      formData.append("InfoDocumentos", JSON.stringify(this.arraydocumentos));

      // Agregar el array de objetos como JSON en un campo de texto
      formData.append("metadata", JSON.stringify(data));

      this.axios
        .post("/archivosdocumentos/CT0", formData)
        .then((response) => {
          this.documentocon = response.data;
          for (var i = 0; i < this.desserts.length; i++) {
            var InfoArchivo = this.documentocon.filter(
              (item) => item.Documento_ID == this.desserts[i].DocumentoID
            );

            if (InfoArchivo.length > 0) {
              var Icono = "mdi-file-account";
              InfoArchivo = InfoArchivo[0].DocumentosExistentes[0];
              if (InfoArchivo.Formato == ".pdf") {
                Icono = "mdi-file-powerpoint";
              } else if (
                InfoArchivo.Formato == ".png" ||
                InfoArchivo.Formato == ".jpg"
              ) {
                Icono = "mdi-camera-image";
              } else if (InfoArchivo.Formato == ".xlsx") {
                Icono = "mdi-file-excel";
              } else if (
                InfoArchivo.Formato == ".doc" ||
                InfoArchivo.Formato == ".docx"
              ) {
                Icono = "mdi-file-word";
              } else if (
                InfoArchivo.Formato == ".mp3" ||
                InfoArchivo.Formato == ".wav"
              ) {
                Icono = "mdi-microphone";
              } else if (InfoArchivo.Formato == "msg") {
                Icono = "mdi-email";
              } else if (
                InfoArchivo.Formato == ".zip" ||
                InfoArchivo.Formato == ".tar"
              ) {
                Icono = "mdi-folder-zip";
              }
              this.desserts[i].IconoArchivo = Icono;
              this.desserts[i].DescArchivo =
                InfoArchivo.Nombre + InfoArchivo.Formato;
              this.desserts[i].MuestraArchivo = true;
            } else {
              this.desserts[i].MuestraArchivo = false;
              this.desserts[i].IconoArchivo = null;
              this.desserts[i].DescArchivo = null;
            }
          }
        })
        .catch((e) => console.log(e))
        .finally(() => {
          this.progreso = false;
        });
    },

    //Limpieza de campos
    clear() {
      this.dessertsresult = [];
      this.desserts = [];
      this.arraydocumentos = [];
      var Documento = this.$store.getters.MDocumentos;
      if (this.item == null) {
        if (
          this.infollaves.IDServicio != null &&
          this.infollaves.IDServicio > 0
        ) {
          this.desserts = Documento.filter(
            (item) =>
              item.ServicioID1 == this.infollaves.IDServicio ||
              item.ServicioID2 == this.infollaves.IDServicio ||
              item.ServicioID3 == this.infollaves.IDServicio ||
              item.ServicioID4 == this.infollaves.IDServicio ||
              item.ServicioID5 == this.infollaves.IDServicio
          );
        } else if (this.infollaves.Contrato != null) {
          this.desserts = Documento.filter(
            (item) => item.VisibleContratos == "S"
          );
        } else if (
          this.infollaves.IDPoliza != null &&
          this.infollaves.IDPoliza > 0
        ) {
          this.desserts = Documento.filter((item) => item.VisibleCaso == "S");
        }
      } else {
        this.desserts = this.item.Documento;
      }

      for (var i = 0; i < this.desserts.length; i++) {
        if (this.item == null) {
          this.desserts[i].index = i;
        }
        this.desserts[i].Combinado = false;
        this.desserts[i].MuestraArchivo = false;
        this.desserts[i].IconoArchivo = "";
        this.desserts[i].DescArchivo = "";
        var inforesult = {
          Documentos_ID: this.desserts[i].DocumentoID,
        };
        this.arraydocumentos.push(inforesult);
      }
      this.consultardoc();
    },

    //Seleccion de archivo
    selectFile() {
      if (this.archivo != null) {
        this.$refs.archivo.value = null;
      }
      this.archivo = null;
      var InfoContenido = this.dessertsresult.filter(
        (item) => item.Documentos_ID != this.itemdocumento.DocumentoID
      );
      if (InfoContenido.length > 0) {
        this.dessertsresult = InfoContenido;
      }
    },

    // Cambio de archivo
    async ChangeArchivo(event) {
      this.archivo = event.target.files[0];
      if (event.target.files.length > 0) {
        if (this.archivo.size / 1000000 <= 500 && this.archivo.size > 0) {
          var tamaniomb = this.archivo.size / 1000000;
          var formatodocsplit = this.archivo.name.split(".");
          var nombredoc = formatodocsplit[0];
          var formatodoc = formatodocsplit[1];
          var Icono = "mdi-file-account";
          if (formatodoc == "pdf") {
            Icono = "mdi-file-powerpoint";
          } else if (formatodoc == "png" || formatodoc == "jpg") {
            Icono = "mdi-camera-image";
          } else if (formatodoc == "xlsx") {
            Icono = "mdi-file-excel";
          } else if (formatodoc == "doc" || formatodoc == "docx") {
            Icono = "mdi-file-word";
          } else if (formatodoc == "mp3" || formatodoc == "wav") {
            Icono = "mdi-microphone";
          } else if (formatodoc == "msg") {
            Icono = "mdi-email";
          } else if (formatodoc == "zip" || formatodoc == "tar") {
            Icono = "mdi-folder-zip";
          }
          this.desserts[this.itemdocumento.index].IconoArchivo = Icono;
          this.desserts[this.itemdocumento.index].DescArchivo =
            this.archivo.name;

          var inforesult = {
            Documentos_ID: this.itemdocumento.DocumentoID,
            Archivo: this.archivo,
          };

          this.dessertsresult.push(inforesult);
        }
      }
    },

    //Subir Archivo
    SubirArchivo(item, viewanex) {
      this.itemdocumento = item;

      this.vistanex = viewanex;
      this.dessertsvista = [];
      if (viewanex == 1) {
        if (item.TipoContenido == "1" || item.TipoContenido == "2") {
          this.desserts[this.itemdocumento.index].IconoArchivo = null;
          this.desserts[this.itemdocumento.index].DescArchivo = null;
          this.$refs.archivo.click();
        } else {
          if (!this.desserts[this.itemdocumento.index].Combinado) {
            this.desserts[this.itemdocumento.index].Combinado = true;
            this.desserts[this.itemdocumento.index].IconoArchivo =
              "mdi-file-account";
            this.desserts[this.itemdocumento.index].DescArchivo =
              "Plantilla: " +
              this.itemdocumento.NombrePlantilla +
              "." +
              this.itemdocumento.FormatoPlantilla;
            var inforesult = {
              Documentos_ID: this.itemdocumento.DocumentoID,
            };
            this.dessertsresult.push(inforesult);
          } else {
            this.desserts[this.itemdocumento.index].IconoArchivo = null;
            this.desserts[this.itemdocumento.index].DescArchivo = null;
            this.desserts[this.itemdocumento.index].Combinado = false;
            var InfoContenido = this.dessertsresult.filter(
              (itemdato) =>
                itemdato.Documentos_ID != this.itemdocumento.DocumentoID
            );
            if (InfoContenido.length > 0) {
              this.dessertsresult = InfoContenido;
            }
          }
        }
      } else if (viewanex == 2) {
        var inforesult = {
          Documentos_ID: this.itemdocumento.Documento_ID,
        };
        this.dessertsvista.push(inforesult);
        this.save();
      } else if (viewanex == 3) {
        var inforesult = {
          Documentos_ID: this.itemdocumento.Documento_ID,
        };
        this.dessertsvista.push(inforesult);

        if (this.itemdocumento.TipoContenido == "5") {
          this.TipoDocumemto = this.itemdocumento.DocumentoID;
        }
        this.consolidardocumentos(this.dessertsvista);
      }
    },

    // Documento Versión Actual
    DocumentoActual(registro) {
      this.TipoDocumemto = registro.DescDocumento_ID;
      this.RutaFisica = null;
      this.LinkDocumento = null;
      this.NombreDocumento = null;
      this.Formato = null;
      this.vistanex == 3;
      var documentoconsulta = this.documentocon.filter(
        (item) => item.Documento_ID == registro.DocumentoID
      );
      if (documentoconsulta != undefined && documentoconsulta.length > 0) {
        documentoconsulta = documentoconsulta[0];
        this.RutaFisica = documentoconsulta.DocumentosExistentes[0].RutaFisica;
        this.LinkDocumento = documentoconsulta.DocumentosExistentes[0].RutaLink;
        this.NombreDocumento = documentoconsulta.DocumentosExistentes[0].Nombre;
        this.Formato = documentoconsulta.DocumentosExistentes[0].Formato;
        this.progreso = true;
        // Consult Archivo
        this.axios
          .get(
            "/archivosdocumentos/ArchivoEspecifico?rutaComplementaria=" +
              this.RutaFisica +
              "&nombreArchivo=" +
              this.NombreDocumento
          )
          .then((response) => {
            this.LinkDocumento = response.data;
            this.modal = true;
          })
          .catch((e) => console.log(e))
          .finally(() => {
            this.progreso = false;
          });
      }
    },

    // Chane Histórico de documentos
    historicoconsultadocumentos(registro) {
      var documentoconsulta = this.documentocon.filter(
        (item) => item.Documento_ID == registro.DocumentoID
      );
      this.itemconsultadocumento = null;
      if (documentoconsulta != undefined && documentoconsulta.length > 0) {
        documentoconsulta = documentoconsulta[0];
        this.itemconsultadocumento = documentoconsulta.DocumentosExistentes;
        this.modal1 = true;
      }
    },

    // Consolidar documentos
    consolidardocumentos(item) {
      this.modalConsolidar = true;
    },
  },
  mounted() {
    this.clear();
  },
};
</script>
